module.exports = __webpack_public_path__ + "staticcomp/img/share.5a10f00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/1/share.jpg
// module id = tN0T
// module chunks = 39